import { jsx, jsxs } from 'react/jsx-runtime';
import { cva } from 'class-variance-authority';
import { IntelligenceLogo } from '../Logos/IntelligenceLogo.js';
import { ProLogo } from '../Logos/ProLogo.js';
import { MCAILogo } from '../Logos/MCAILogo.js';

const listItemStyles = cva([
    "mci-cursor-pointer mci-transition-colors mci-duration-slow hover:mci-bg-gray-200",
    "not-last-child:mci-border-b-1 not-last-child:mci-border-gray-300",
], {
    variants: {
        isDisabled: {
            true: "mci-cursor-not-allowed mci-bg-gray-100 mci-opacity-40",
            false: "hover:mci-bg-primary-100",
        },
        isActive: {
            true: "mci-bg-gray-50",
            false: "",
        },
    },
});
const ProductMenuLink = ({ as, description, isDisabled, href, isActive, logo, ...props }) => {
    const Component = as || "a";
    return (jsx("li", { className: listItemStyles({ isDisabled, isActive }), children: jsxs(Component, { "aria-disabled": isDisabled, className: "mci-block mci-p-s mci-pr-l  mci-no-underline mci-outline-brand focus-visible:mci-outline-2 focus-visible:-mci-outline-offset-2", tabIndex: isDisabled ? -1 : 0, href: isDisabled ? undefined : href, ...props, children: [jsx("div", { className: "mci-mb-1 mci-py-[4px]", children: logo }), jsx("div", { className: "mci-m-0 mci-text-body-xsmall mci-leading-body mci-text-gray-900", children: description })] }) }));
};
const MCIntelligenceMenuLink = ({ as, isActive, ...props }) => (jsx(ProductMenuLink, { "aria-label": "Morning Consult Intelligence", as: as || "a", description: "Dashboard and analyze data", isActive: isActive, logo: jsx(IntelligenceLogo, {}), ...props }));
const MCProMenuLink = ({ as, isActive, ...props }) => (jsx(ProductMenuLink, { "aria-label": "Morning Consult Pro", as: as || "a", description: "Trend reports and analysis", isActive: isActive, logo: jsx(ProLogo, {}), ...props }));
const MCAIMenuLink = ({ as, isActive, ...props }) => (jsx(ProductMenuLink, { "aria-label": "Morning Consult AI", as: as || "a", description: "Instant answers", isActive: isActive, logo: jsx(MCAILogo, {}), ...props }));

export { MCAIMenuLink, MCIntelligenceMenuLink, MCProMenuLink, ProductMenuLink };
